const SITES_QUERY_PARAM = "sites";

export const SERVICES_PATH = "/services";

/**
 * Builds the URL of the services page for the given site(s), e.g.
 * `/services?sites=A&sites=B`. Use this as the `href`/`to` of anchors so the
 * link works with keyboard, middle-click and "open in new tab".
 */
export function buildServicesUrl(
  sites: string[],
  productionArea?: string
): string {
  if (sites.length === 0) return SERVICES_PATH;

  const params = new URLSearchParams();
  sites.forEach((site) => params.append(SITES_QUERY_PARAM, site));
  if (sites.length === 1 && productionArea !== undefined) {
    params.set("productionArea", productionArea);
  }
  return `${SERVICES_PATH}?${params.toString()}`;
}

export function parseProductionAreaFromSearch(
  search: string,
  sites: string[]
): string | undefined {
  return sites.length === 1
    ? (new URLSearchParams(search).get("productionArea") ?? undefined)
    : undefined;
}
